import React, { useEffect, useState } from 'react';
import NavLink from '../NavLink';
import PaymentsBadge from '../PaymentsBadge';
import { isPaymentsCompany } from '../../../../utils/helpers';
import logoSrc from '../../../../assets/images/TripAdmitLogo.png';
import tipDirectLogo from '../../../../assets/images/TipDirectLogo.png';

export function Logo({ user }) {
  const [link, setLink] = useState();

  useEffect(() => {
    //Default link should link to TipDirect homepage
    let tempLink = '/TipDirect';

    if (!user?.companyDetails?.products) tempLink = '/manifest';

    if (user?.companyDetails?.products?.TicketingSystem) {
      tempLink = '/manifest';
    }

    setLink(tempLink);
  }, [user]);

  // Payments companies get the TripAdmit Digital Payments lockup as their nav
  // logo in place of the TipDirect logo (card 105).
  return (
    <NavLink link={link}>
      {isPaymentsCompany(user?.companyId, user) ? (
        <PaymentsBadge />
      ) : (
        <img
          style={{ width: 'auto', height: process.env.REGION === 'EU-TS' ? '60px' : '45px' }}
          alt="Logo Img"
          src={process.env.REGION === 'EU-TS' ? logoSrc : tipDirectLogo}
        />
      )}
    </NavLink>
  );
}

export default Logo;
